import {default as cx} from "classnames"
import {useState} from "react"
import {Modal} from "react-bootstrap"

import {getLocaleDate, QUESTION_TYPE} from "../utilities/general"

import BooleanRow from "./BooleanRow"
import RatingRow from "./RatingRow"
import TextRow from "./TextRow"
import ValueFromApiRow from "./ValueFromApiRow"
import PreceptorFromApi from "./PreceptorFromApi"

const getLayoutElement = (answer, index) => {
    switch (answer.question_type) {
        case QUESTION_TYPE.RANGE_WITH_NOT_APPLICABLE:
        case QUESTION_TYPE.RANGE:
            return (
                <RatingRow
                    num={index + 1}
                    stmt={answer.question}
                    rating={answer.answer}
                    maxRating={answer.question_answers.length}
                />
            )

        case QUESTION_TYPE.NUMBER:
        case QUESTION_TYPE.DATE:
        case QUESTION_TYPE.TEXT:
            // number/date use TextAreaPrompt as a placeholder until dedicated components exist
            return <TextRow num={index + 1} stmt={answer.question} text={answer.answer} />

        case QUESTION_TYPE.BOOLEAN:
            return <BooleanRow num={index + 1} stmt={answer.question} text={answer.answer} />

        case QUESTION_TYPE.SELECT_FROM_API:
            return (
                <ValueFromApiRow
                    num={index + 1}
                    stmt={answer.question}
                    value={answer.answer}
                    apiPath={answer.api_path}
                />
            )

        case QUESTION_TYPE.SELECT_PRECEPTOR:
            return <PreceptorFromApi num={index + 1} stmt={answer.question} value={answer.answer} />

        default:
            console.warn(`No component mapped for question type "${answer.question_type}"`, answer)
            return null
    }
}

export function NhsrModal({nhsrs}) {
    const [showModal, setShowModal] = useState(false)
    const [nhsr, setNhsr] = useState(nhsrs[0])
    return (
        <>
            <button className="btn btn-sm btn-light-primary px-5 me-2" onClick={() => setShowModal(true)}>
                NHSR{nhsrs.length > 1 ? "s" : ""}
            </button>
            <Modal
                dialogClassName="modal-fullscreen modal-fullscreen-lg-down rounded-0"
                show={showModal}
                onHide={() => setShowModal(false)}
                animation={false}
            >
                <Modal.Header closeButton closeVariant="white" className="modal-header">
                    <Modal.Title>
                        New Hire Status Report: Week {nhsr.week_of_orientation}
                        {nhsrs.length > 1 &&
                            nhsrs.map((report, index) => (
                                <button
                                    key={index}
                                    className={cx("ms-3 btn btn-sm", nhsr === report ? "btn-primary" : "btn-secondary")}
                                    onClick={() => setNhsr(report)}
                                >
                                    {getLocaleDate(report.created_date)}
                                </button>
                            ))}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="app-default px-4">
                    {nhsr &&
                        nhsr.answers.map((answer, index) => {
                            const element = getLayoutElement(answer, index)
                            return (
                                <div key={`answer-nhsr-${index}`}>
                                    {element}
                                    <div className="separator border-1 border-secondary my-5"></div>
                                </div>
                            )
                        })}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
